import React, {Component} from 'react';
import {connect} from 'react-redux';
import Const from 'constants';
import Action from 'actions';

class ThemeSwitcher extends Component {
    handleTheme(value) {
        const {dispatch} = this.props;

        window.localStorage.setItem(Const.THEME_LOCAL_STORAGE, value);
        const html = document.querySelector('html');
        html.dataset.isDarkTheme = value;

        dispatch(Action.do('toggleTheme', value));
    }

    render() {
        const {theme} = this.props;

        return (
            <label className="theme-switcher">
                <input
                    type="checkbox"
                    checked={theme.isDarkTheme}
                    onChange={(e) => ::this.handleTheme(e.currentTarget.checked)}
                />

                <svg
                    className="sun-icon"
                    fill="currentColor"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 207.628 207.628"
                >
                    <circle cx="103.814" cy="103.814" r="45.868" />
                    <path d="M103.814,157.183c-29.427,0-53.368-23.941-53.368-53.368s23.941-53.368,53.368-53.368s53.368,23.941,53.368,53.368 S133.241,157.183,103.814,157.183z M103.814,65.446c-21.156,0-38.368,17.212-38.368,38.368s17.212,38.368,38.368,38.368 s38.368-17.212,38.368-38.368S124.97,65.446,103.814,65.446z" />
                    <path d="M103.814,39.385c-4.142,0-7.5-3.358-7.5-7.5V7.5c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5v24.385  C111.314,36.027,107.956,39.385,103.814,39.385z" />
                    <path d="M103.814,207.628c-4.142,0-7.5-3.358-7.5-7.5v-24.385c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5v24.385 C111.314,204.271,107.956,207.628,103.814,207.628z" />
                    <path d="M200.128,111.314h-24.385c-4.142,0-7.5-3.358-7.5-7.5s3.358-7.5,7.5-7.5h24.385c4.142,0,7.5,3.358,7.5,7.5 S204.271,111.314,200.128,111.314z" />
                    <path d="M31.885,111.314H7.5c-4.142,0-7.5-3.358-7.5-7.5s3.358-7.5,7.5-7.5h24.385c4.142,0,7.5,3.358,7.5,7.5 S36.027,111.314,31.885,111.314z" />
                    <path d="M154.676,60.452c-1.919,0-3.839-0.732-5.303-2.197c-2.929-2.929-2.929-7.678,0-10.606l17.243-17.242 c2.929-2.929,7.678-2.93,10.606,0c2.929,2.929,2.929,7.678,0,10.606l-17.243,17.242C158.515,59.72,156.595,60.452,154.676,60.452z" />
                    <path d="M35.709,179.419c-1.919,0-3.839-0.732-5.303-2.197c-2.929-2.929-2.929-7.678,0-10.606l17.243-17.243 c2.929-2.929,7.678-2.929,10.606,0c2.929,2.929,2.929,7.678,0,10.606l-17.243,17.243C39.548,178.687,37.629,179.419,35.709,179.419z" />
                    <path d="M171.918,179.419c-1.919,0-3.839-0.732-5.303-2.197l-17.243-17.243c-2.929-2.929-2.929-7.678,0-10.606 c2.929-2.929,7.678-2.929,10.606,0l17.243,17.243c2.929,2.929,2.929,7.678,0,10.606 C175.757,178.687,173.838,179.419,171.918,179.419z" />
                    <path d="M52.952,60.452c-1.919,0-3.839-0.732-5.303-2.197L30.406,41.013c-2.929-2.929-2.929-7.677,0-10.606 c2.929-2.929,7.678-2.93,10.606,0l17.243,17.242c2.929,2.929,2.929,7.677,0,10.606C56.791,59.72,54.872,60.452,52.952,60.452z" />
                </svg>

                <svg
                    className="moon-icon"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 542.9 542.7"
                >
                    <path
                        fill="currentColor"
                        d="M378.6,45.7c4.7-13,23.2-13,27.9,0l16,44.5c1.5,4.2,4.8,7.4,9,8.9l45,15.8c13.1,4.6,13.1,22.9,0,27.5 l-45,15.8c-4.2,1.5-7.5,4.7-9,8.9l-16,44.5c-4.7,13-23.2,13-27.9,0l-16-44.5c-1.5-4.2-4.8-7.4-9-8.9l-45-15.8 c-13.1-4.6-13.1-22.9,0-27.5l45-15.8c4.2-1.5,7.5-4.7,9-8.9L378.6,45.7z"
                    />
                    <path
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="40"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21.2,269.7 C21.2,408.5,137.1,521,279.9,521c110,0,203.9-66.7,241.3-160.7c-29.6,13.5-62.7,21.1-97.6,21.1c-127,0-229.9-100-229.9-223.4 c0-51.6,18-99.1,48.2-136.9C117.1,38.8,21.2,143.4,21.2,269.7z"
                    />
                </svg>
            </label>
        );
    }
}

function mapStatesToProps(state) {
    const {teamsInfo, theme} = state;
    return {
        teamsInfo,
        theme,
    };
}

export default connect(mapStatesToProps)(ThemeSwitcher);
